"use client";
import Banner from "@/components/banner";
import TabList from "@/components/newtabList";

import styles from "./index.module.scss";
import { useTabsActive } from "@/utils/commonHooks";
import _ from "lodash";

export default function AboutLayout({ children }) {
  const [activeIndex, changeActive]: any = useTabsActive("about");

  return (
    <div className={styles["aboutBox"] + " " + " mb120"}>
      <Banner bannerId="about" activeIndex={activeIndex} />
      <div className={styles["aboutCont"]}>
        <TabList
          tabId="about"
          changeActive={changeActive}
          activeIndex={activeIndex}
        />
        {children}
      </div>
    </div>
  );
}
